import { inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ErrorDialogComponent } from "@shared/components/error-dialog/error-dialog.component";
import { hasNestedEmptyValues } from "@shared/utils/objects.util";
import { switchMap } from "rxjs";
import { map } from "rxjs/operators";
import { storeActions } from "./actions";

export const storeDetailsEffect = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(storeActions.setStoreDetails),
      switchMap((action: ReturnType<typeof storeActions.setStoreDetails>) => {
        const data = {
          storeName: action.storeName,
          storeBranding: action.storeBranding,
          branch: action.branch,
        };

        // Assuming your service call or validation logic here
        if (!hasNestedEmptyValues(data)) {
          return [storeActions.setStoreDetailsSuccess({ storeDetails: data })];
        } else {
          return [storeActions.setStoreDetailsFail({})];
        }
      })
    );
  },
  { functional: true }
);

export const storeDetailsFailedEffect = createEffect(
  (actions$ = inject(Actions), dialog = inject(MatDialog)) => {
    return actions$.pipe(
      ofType(storeActions.setStoreDetailsFail),
      map(() => {
        dialog.open(ErrorDialogComponent, {
          data: {
            errorMessage: "Could not find the store details",
          },
        });
      })
    );
  },
  { dispatch: false, functional: true }
);
